import Vue from "vue";
import Vuex from "vuex";
Vue.use( Vuex );

import resourceCustomer from "./storeCustomer";
import resourceEstimate from "./storeEstimate";
import resourceContract from "./storeContract";
import resourceReservation from "./storeReservation";
import resourcePost from "./storePost";
import resourceEtc from "./storeEtc";
import resourceRepair from "./storeRepair";

const store = new Vuex.Store({
  modules: {
    customer: resourceCustomer,
    estimate: resourceEstimate,
    contract: resourceContract,
    reservation: resourceReservation,
    post: resourcePost,
    etc: resourceEtc,
    repair: resourceRepair,
  },
  state: {
    prev: '',
    pagename: "",
    isProcessor: false,
    config: {
      //  hostName:  process.env.NODE_ENV === 'debug' ? 'https://dev-api.insunetfc.com': 'http://localhost:3901',
      hostName: 'https://dev-api.insunetfc.com',
      isTouchDevice: /iPhone|iPad|iPod|Android/i.test( navigator.userAgent ),
      parking: false
    },
    combobox: null,
    dimmer: false,
    allianceImgList: [
      { name: '삼성', value: '/static/alliance/company_ss.png' },
      { name: '흥국', value: '/static/alliance/company_hk.png' },
      { name: '메리츠', value: '/static/alliance/company_mz.png' },
      { name: '롯데', value: '/static/alliance/company_lt.png' },
      { name: '한화', value: '/static/alliance/company_hw.png' },
      { name: '현대', value: '/static/alliance/company_hd.png' },
      { name: 'KB', value: '/static/alliance/company_kb.png' },
      { name: 'DB', value: '/static/alliance/company_db.png' },

      { name: '리이나', value: '/static/alliance/company_ln.png' },
      { name: 'MG', value: '/static/alliance/company_mg.png' },
    ]
  },
  mutations: {
    SET_PAGENAME( state, payload ){
      state.pagename = payload.name;
    },
    SET_IS_PROCESSOR( state, payload ){
      state.isProcessor = payload;
    },
    SET_COMBOBOXSTATE( state, value ){
      state.combobox = value
    },
    SET_DIMMER( state, value ){
      state.dimmer = value
    },
    SET_PREV_PATH(state, payload) {
      state.prev = payload.path
    }
  },
});

export default store;
